import React from 'react';
import Banner from '../components/service/banner';
import Splservice from '../components/service/splservice';

function servicepage() {
  return (
    <div>
        <Banner/>
        <Splservice/>
    </div>
  )
}

export default servicepage